import { v4 as uuidv4 } from "uuid";
import { WEB_UNIQUE_KEY } from "../constants/Storage";

export const setWebUniqueKey = new Promise((resolve) => {
    const key = localStorage.getItem(WEB_UNIQUE_KEY);
    if (!key) localStorage.setItem(WEB_UNIQUE_KEY, uuidv4());
    resolve(true);
});